// Breaks Keycloak redirect loops. Keycloak's SSO session is still valid after the app
// "logs out", so a rejected API call used to bounce login -> app -> login forever
// (until the backend rate limiter stopped it). Allow a few SSO redirects per minute,
// then send the user to /auth-error instead.
const KEY = "cedi.ssoRedirects";
const WINDOW_MS = 60_000;
const MAX_REDIRECTS = 3;

const read = (): number[] => {
  try {
    const raw = JSON.parse(sessionStorage.getItem(KEY) || "[]");
    const now = Date.now();
    return Array.isArray(raw) ? raw.filter((t) => typeof t === "number" && now - t < WINDOW_MS) : [];
  } catch {
    return [];
  }
};

/** Call right before redirecting to Keycloak. Returns false when the loop limit is reached. */
export function registerSsoRedirect(): boolean {
  const recent = read();
  if (recent.length >= MAX_REDIRECTS) return false;
  try {
    sessionStorage.setItem(KEY, JSON.stringify([...recent, Date.now()]));
  } catch {
    /* storage unavailable: fall through, never block the login */
  }
  return true;
}

/** Call once the app loaded successfully for the logged-in user. */
export function resetSsoRedirects(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

export type AuthErrorReason = "loop" | "forbidden" | "rate";
export const authErrorUrl = (reason: AuthErrorReason) => `/auth-error?reason=${reason}`;
